import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Any 402 Payment Required from the backend is an "upgrade required" gate.
// Dispatch a global event so the mounted <UpgradeModal /> can render a prompt.
// We still re-throw so callers can decide how to react (e.g. keep a form open).
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      const detail = err.response.data?.detail || {};
      window.dispatchEvent(
        new CustomEvent("peak:upgrade-required", {
          detail: {
            current_plan: detail.current_plan,
            required_plan: detail.required_plan,
            message: detail.message,
            error: detail.error,
            limit: detail.limit,
            count: detail.count,
          },
        }),
      );
    }
    return Promise.reject(err);
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object" && typeof detail.message === "string")
    return detail.message;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
